import * as React from 'react'
import DashboardLayout from '../../../shared/LayoutContainers/DashboardLayout'
import DashboardNavbar from '../../../shared/Navbars/DashboardNavbar'
import AgendaForm from './AgendaForm'

export default function ListScreen() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AgendaForm />
    </DashboardLayout>
  )
}
